<template>
  <div>
    <contact-list :title="contactData.title" :contacts="imQyhContactData" />
    <team-list :title="groupData.title" :im-teams="groupData.teams" />
  </div>
</template>

<script>
import ContactList from './ContactList'
import TeamList from '../../team/list/TeamList.vue'
import { mapState } from 'vuex'
export default {
  name: 'Contacts',
  components: { ContactList, TeamList },
  props: {
  },
  computed: {
    ...mapState({
      imAccount: state => state.imAccount,
      imQyhContactData: state => state.imQyhContactData,
      imTeamsArr: state => state.imTeamsArr
    }),
    contactData () {
      return {
        title: '企业火',
        contacts: this.imQyhContactData
      }
    },
    groupData () {
      return {
        title: '群聊',
        teams: this.imTeamsArr
      }
    }
  },
  data () {
    return {
    }
  },
  watch: {
    imAccount () {
      this.getQyhContacts()
    }
  },
  methods: {
    getQyhContacts () {
      this.$axios.get('/api/admin/im/enterprise/accounts', { loadingClose: true })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            console.log('imTeamsArr', this.imTeamsArr)
            this.$store.dispatch('imQyhContactDataAction', data.data)
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/right/contacts/Contacts.vue